module.exports = __webpack_public_path__ + "img/1.9d90343e.jpg";